import { MeetingType } from "./meetingTypeToTranslationKey";

const DEFAULT_MEETING_COLOR = "black";

/** Saturated accent / border color per meeting type */
const MEETING_TYPE_BORDER_COLORS: Record<MeetingType, string> = {
  VISIT: "#f54758",
  TAKING_MEASUREMENTS: "#ad7611",
  FIRST_MEASUREMENT: "#12ad27",
  SECOND_MEASUREMENT: "#4899ad",
  OTHER: "#bebebf",
  CONTRACT: "#ffff5b",
  RECEIVING: "#ad579f",
  WAITING_LIST: "#CFE2F3",
  NOTE: "#bebebf",
  SECOND_MEASUREMENT_AND_RECEIVING: "#fdeb92",
  SECOND_VISIT: "#e67e22",
  THIRD_VISIT: "#c0392b",
  CONSULTING_SERVICES: "#8e44ad",
};

/** Pastel fill / background color per meeting type */
const MEETING_TYPE_BACKGROUND_COLORS: Record<MeetingType, string> = {
  VISIT: "#FADADD",
  TAKING_MEASUREMENTS: "#ad7611",
  FIRST_MEASUREMENT: "#b4fab5",
  SECOND_MEASUREMENT: "#b1c8fa",
  OTHER: "#bebebf",
  CONTRACT: "#ffff5b",
  RECEIVING: "#fabcf6",
  WAITING_LIST: "#CFE2F3",
  NOTE: "grey",
  SECOND_MEASUREMENT_AND_RECEIVING: "#ffff5b",
  SECOND_VISIT: "#fad7a0",
  THIRD_VISIT: "#f5b7b1",
  CONSULTING_SERVICES: "#d7bde2",
};

export const getMeetingBorderColor = (type: MeetingType) => {
  return MEETING_TYPE_BORDER_COLORS[type] ?? DEFAULT_MEETING_COLOR;
};

export const getMeetingColor = (type: MeetingType) => {
  return MEETING_TYPE_BACKGROUND_COLORS[type] ?? DEFAULT_MEETING_COLOR;
};
